import React from "react";
import { NavLink as RouterLink, useLocation, useHistory } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Button, ListItem, makeStyles } from "@material-ui/core";
import { ReactSVG } from "react-svg";
import { callHelpDesk } from "../../helpers/api/api";
import { callGetEventToken } from "../../reducers/events";
import { connect } from "react-redux";
import { useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  item: {
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0,
    color: theme.palette.leftBar.text,
    "& a": {
      "& span": {
        display: "flex !important",
        alignItems: "center !important",
        justifyContent: "center !important",
        //gap: "8px !important",
      },
    },
  },
  button: {
    fontWeight: "400",
    justifyContent: "flex-start",
    letterSpacing: 0,
    padding: "12px 5px 12px 25px",
    textTransform: "none",
    width: "100%",
  },
  icon: {
    marginRight: theme.spacing(1),
    color: theme.UpdateTheme.text_color,
  },
  title: {
    marginRight: "auto",
  },
  iconWhite: {
    display: "none",
    marginRight: " 8px",
  },
  active: {
    fontWeight: "400",
    color: theme.UpdateTheme.text_color,
    borderRadius: "0px ",
    background: theme.UpdateTheme.button_color,
    "& $title": {
      fontWeight: "400",
    },
    "& $icon": {
      color: theme.palette.primary.text,
    },
    "&:focus": {
      backgroundColor: theme.UpdateTheme.button_color,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.UpdateTheme.text_color,
      },
    },
    "&:hover": {
      backgroundColor: theme.UpdateTheme.button_color,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.UpdateTheme.text_color,
      },
    },
  },
  iconswrapper: {
    "& div": {
      display: "flex",
      width: "20px",
      height: "20px",
    },
  },
  iconed: {
    marginRight: "6px !important",
    "& svg": {
      fill: ({ color }) => color,
      width: ({ size }) => size,
      height: ({ size }) => size,
      transform: ({ transform }) => transform,
      "& path": {
        fill: ({ color }) => color,
      },
    },
  },
}));

const NavItem = ({
  className,
  href,
  icon,
  title,
  callGetEventToken,
  ...rest
}) => {
  const location = useLocation();
  const history = useHistory();
  const isDummy =
    !href ||
    href === "#" ||
    [
      "Coding Platform",
      "Content Authoring Tool",
      "Video Conferencing",
    ].includes(title);
  // const isActive = !isDummy && location.pathname === href;
  const isActive =
    !isDummy &&
    (location.pathname === href || location.pathname.startsWith(`${href}/`));

  const theme = useTheme();
  const props = {
    color: isActive ? "#ffffff" : theme.palette.text.primary,
    size: "20px",
    transform: "none",
  };
  const classes = useStyles(props);

  const handleHelpDeskClick = () => {
    window.open("https://ide.judge0.com");
  };

  const handleContent = () => {
    window.open("https://content.brihha.in");
  };

  const handleInstant = () => {
    const body = { key: "abc" };
    callGetEventToken(body).then((res) => {
      window.open(res?.results, "_blank");
      localStorage.setItem("url", res?.results);
    });
  };

  const handleWorkforce = () => {
    history.push("/workforce-onboarding")
  }

  const handleClick = () => {
    if (title === "Coding Platform") handleHelpDeskClick();
    else if (title === "Content Authoring Tool") handleContent();
    else if (title === "Video Conferencing") handleInstant()
    else if (title === "Workforce Onboarding") handleWorkforce()
  };

  return (
    <ListItem
      className={clsx(classes.item, className)}
      disableGutters
      {...rest}
    >
      <Button
        className={clsx(classes.button, {
          [classes.active]: isActive,
        })}
        component={!isDummy ? RouterLink : "div"}
        to={!isDummy ? href : undefined}
        onClick={handleClick}
      >
        {icon && (
          <ReactSVG
            src={require("../../images/" + icon + ".svg")}
            className={`${classes.iconswrapper} ${classes.iconed}`}
          />
        )}
        <span className={classes.title}>{title}</span>
      </Button>
    </ListItem>
  );
};

NavItem.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  callGetEventToken: (inputs) => dispatch(callGetEventToken(inputs)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NavItem);
